import React from 'react';
import createHistory from 'history/createBrowserHistory';
import HelmetHeader from '../../components/HelmetHeader';

import {
  Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import {
  Provider
} from 'react-redux';

import {
  createAppStore
} from '../../stores/AppStore';

import {
  PrivateRoute,
  Home,
  ForgotPassword,
  ResetPassword,
  Login,
  SignUp,
  Profile,
  ThankYou,
  AccountCreated,
  AboutUs
} from '../';

import NotificationList from '../../components/NotificationList/NotificationList';

import {
  Navbar,
  Footer,
  Player,
  ModalLogin
} from '../../components';

import { getProfileInformation } from '../../actions/UserActions';
import { getFavorites } from '../../actions/FavoritesActions';
import { getFavoritesOther } from '../../actions/FavoritesActions';
import { logOutAction } from '../../actions/UserActions';

import 'bulma/css/bulma.css';
import './app.style.css';
import './icomoon.style.css';
// I'm adding this extra font file because I don't have the selection.json file
// for the original and I don't have time to re-create it from scratch.
import '../../fonts/icomoon-2/style.css';
import 'react-select/dist/react-select.css';

const store = createAppStore();

const user = localStorage.getItem('user');
const parsedUser = JSON.parse(user);

const history = createHistory();
history.listen((_location, _action) => {
  window.scrollTo(0, 0);
});

// const viola_url='http://52.200.144.109:3006/favorites';
const viola_url='https://www.voilacatalog.com/favorites';
const current_url=window.location.href;
const uid_from_url=''+current_url.replace(viola_url+'?list=', '');
if (user) {
  store.dispatch({ type: 'AUTHENTICATED_USER', user: parsedUser });
  store.dispatch(getProfileInformation(parsedUser.token));

    console.log('fetch_other1');
    console.log(uid_from_url);
    console.log(viola_url);
  const uid=parsedUser.user_id;
  // if(uid_from_url!=''&&uid_from_url!=viola_url&&uid_from_url!='http://52.200.144.109:3006/') {
  if(uid_from_url!=''&&uid_from_url!=viola_url&&uid_from_url!='https://www.voilacatalog.com/') {
    store.dispatch(getFavoritesOther());
    console.log('fetch_other');
    console.log(uid_from_url);
    console.log(viola_url);
  }

  store.dispatch(getFavorites());
} 
var user_auth=false;
if(typeof parsedUser!='undefined' && parsedUser!=null) user_auth=true;

const isAuthenticated = user_auth;
export const AppRouter = () => (
   <Provider store={store}>
    <Router history={history}>
      <section className="Site">
        <div className="Site-content">
          <HelmetHeader />
          <Navbar />
          <Switch>
            <Route path="/forgot-password" component={ForgotPassword} exact />
            <Route path="/reset-password" component={ResetPassword} exact />

            <Route path="/login" component={Login} exact />
            <Route path="/success" isAuthenticated={isAuthenticated} component={AccountCreated} exact />
            <Route path="/sign-up" component={SignUp} exact />
            {/* <Route path="/favorites" component={Favorites} exact /> */}

            <PrivateRoute path="/profile" isAuthenticated={isAuthenticated} component={Profile} />

            <PrivateRoute path="/thank-you" isAuthenticated={isAuthenticated} component={ThankYou} exact />
            <PrivateRoute path="/about-us" isAuthenticated={isAuthenticated} component={AboutUs} exact />


            <PrivateRoute path="/" isAuthenticated={isAuthenticated} component={Home} />
            <Redirect to="/" />
          </Switch>
          <ModalLogin />
          <Player />
          <NotificationList />
        </div>
        <Footer />
      </section>
    </Router>
  </Provider>
  );



// WEBPACK FOOTER //
// ./src/routes/StripedRouter/StripedRouter.js